// import { useSearchParams } from "react-router-dom";

// const EditFFDPage = () => {
//     const [searchParams] = useSearchParams();
//     const technologyParkId = searchParams.get("technologyParkId");

//     return (
//         <div>
//             <h1>Edit Page</h1>
//             <p>Editing Technology Park with ID: {technologyParkId}</p>
//             {/* Add your edit form here */}
//         </div>
//     );
// };

// export default EditFFDPage;


import { useLocation } from "react-router-dom";

const EditFFDPage = () => {
    const location = useLocation();
    const rowData = location.state?.rowData; // Extract row data

    if (!rowData) {
        return <div>No data available to edit</div>;
    }

    return (
        <div>
            <h1>Edit Page</h1>
            <p>Editing Technology Park with the following details:</p>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        {Object.keys(rowData).map((key) => (
                            <th key={key}>{key}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {Object.values(rowData).map((value, index) => (
                            <td key={index}>{value}</td>
                        ))}
                    </tr>
                </tbody>
            </table>

            {/* Add your edit form below, prefilled with rowData */}
            <form>
                {/* Example field */}
                <div className="form-group">
                    <label htmlFor="technologyParkId">Technology Park ID</label>
                    <input
                        type="text"
                        id="technologyParkId"
                        className="form-control"
                        value={rowData.technologyParkId}
                        readOnly
                    />
                </div>
                {/* Add additional fields based on rowData */}
            </form>
        </div>
    );
};

export default EditFFDPage;
